import Select from "react-select";
import { Col, Row } from "react-bootstrap";
import { DebounceInput } from "react-debounce-input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

import {
  FILTER_LABEL,
  EMPTY_ARRAY_LENGTH,
  featureDropdownOptions,
  featureFlagsTabs,
  featureFlagsUi,
  MENU_PLACEMENT,
} from "../../constants";
import {
  customStyle,
  Option,
  ValueContainer,
  onKeyDownHandler,
} from "../../../../shared";
import { customFeatureStyle } from "./utility";

const FeatureFlagFilters = ({
  search,
  activeTab,
  brandValue,
  brandOptions,
  brandsLoading,
  statusValue,
  statusOptions,
  featureFlagStatus,
  selectedFeatures,
  onSearchChange,
  onSearchReset,
  onBrandChange,
  onStatusChange,
  onFeatureChange,
}) => {
  return (
    <Row className="py-2 g-2">
      <Col lg={3} md={4} xs={12}>
        <div className="input-group">
          <span className="input-group-text bg-white text-secondary">
            <FontAwesomeIcon icon={faSearch} />
          </span>
          <DebounceInput
            type="text"
            debounceTimeout={featureFlagsUi.SEARCH_DEBOUNCE_MS}
            placeholder="Search"
            className="form-control rounded-end"
            onChange={onSearchChange}
            value={search}
          />
          {search?.length > EMPTY_ARRAY_LENGTH && (
            <span
              role="button"
              tabIndex={0}
              data-testid="reset-button"
              className="user-input-reset pe-0 me-0 rounded"
              onClick={onSearchReset}
              onKeyDown={(e) => onKeyDownHandler(e, onSearchReset)}
            >
              <i className="fa fa-times pe-md-0 pe-2" />
            </span>
          )}
        </div>
      </Col>
      <Col lg={3} md={4} xs={12}>
        <Select
          isSearchable={true}
          maxMenuHeight={featureFlagsUi.SELECT_MENU_MAX_HEIGHT_PX}
          menuPlacement={MENU_PLACEMENT.AUTO}
          styles={customStyle}
          value={brandValue}
          options={brandOptions || []}
          placeholder="Select Brand"
          getOptionValue={(e) => e.id}
          getOptionLabel={(e) => e.name}
          className="store-brandDropdown"
          components={{
            IndicatorSeparator: () => null,
          }}
          isClearable
          isLoading={brandsLoading}
          onChange={onBrandChange}
          isDisabled={brandsLoading}
        />
      </Col>
      {activeTab !== featureFlagsTabs.aiReply && (
        <>
          <Col lg={3} md={4} xs={12}>
            <Select
              maxMenuHeight={featureFlagsUi.SELECT_MENU_MAX_HEIGHT_PX}
              menuPlacement={MENU_PLACEMENT.AUTO}
              styles={customStyle}
              value={statusValue}
              options={statusOptions}
              placeholder="Select Status"
              className="store-brandDropdown"
              isClearable
              components={{
                IndicatorSeparator: () => null,
              }}
              onChange={onStatusChange}
            />
          </Col>
          {activeTab === featureFlagsTabs.featureFlags && (
            <Col lg={3} md={4} xs={12}>
              <Select
                isMulti
                styles={customFeatureStyle}
                name="feature"
                placeholder={FILTER_LABEL.ALL}
                maxMenuHeight={featureFlagsUi.SELECT_MENU_MAX_HEIGHT_PX}
                menuPlacement={MENU_PLACEMENT.AUTO}
                isDisabled={!featureFlagStatus}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                getOptionLabel={(option) => option.label}
                options={featureDropdownOptions}
                components={{
                  IndicatorSeparator: () => null,
                  Option,
                  ValueContainer,
                }}
                value={selectedFeatures}
                onChange={onFeatureChange}
                className="rounded bg-secondary bg-opacity-25 w-100"
              />
            </Col>
          )}
        </>
      )}
    </Row>
  );
};

export default FeatureFlagFilters;
